/**
 * Keyboard access to clickable table rows. A UTable with `on-select` renders each row
 * as `role="button"` with `tabindex="0"` — focusable — but reacts to clicks only, so a
 * keyboard user could reach a row and not open it. Enter or Space on a focused row
 * clicks it, as on a button; keys pressed inside the row's own controls (its ⋮, a
 * field) are theirs.
 */
const CLICKABLE_ROW = 'tr[data-slot="tr"][role="button"]'

export function onTableRowKey(event: KeyboardEvent): void {
    if (event.key !== 'Enter' && event.key !== ' ') return

    const target = event.target
    if (!(target instanceof HTMLElement) || !target.matches(CLICKABLE_ROW)) return

    // Space would also scroll the page.
    event.preventDefault()
    target.click()
}

export function installTableRowKeyboard(root: Document = document): void {
    root.addEventListener('keydown', onTableRowKey)
}
